import { createContext } from "react";

import { IBookingPrepareConflict } from "@ryde/shared";

export interface IBulkPreviewStepUploadConflictsContext {
  conflicts: IBookingPrepareConflict[] | null;
}

export const BulkPreviewStepUploadConflictsContext =
  createContext<IBulkPreviewStepUploadConflictsContext>({
    conflicts: null,
  });
